import { PropsWithChildren, useMemo, useState } from 'react';
import { ModalContext } from '../';
import type { ModalContextT, ModalDataT } from './types';
import Modals from '../../features/modals';

const ModalProvier = ({ children }: PropsWithChildren): JSX.Element => {
  const [modalData, setModalData] = useState<ModalDataT[]>([]);

  const onClose = (): void => {
    setModalData([]);
  };

  const onCloseByName = (name: string): void => {
    setModalData((prevState) =>
      prevState.filter((modal) => modal.name !== name),
    );
  };

  const onOpen = (modal: ModalDataT): void => {
    setModalData((prevState) => [...prevState, modal]);
  };

  const providerValue: ModalContextT = useMemo(
    () => ({ modals: modalData, onClose, onOpen }),
    [modalData],
  );

  return (
    <ModalContext.Provider value={providerValue}>
      {children}
      {modalData.map((_, i) => (
        <Modals key={i} index={i} onCloseByName={onCloseByName} />
      ))}
    </ModalContext.Provider>
  );
};

export default ModalProvier;
